import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CaretRight, ChartLineUp } from "@phosphor-icons/react";

export default function ParentDashboard() {
  const [players, setPlayers] = useState(null);

  useEffect(() => {
    api.get("/players").then((r) => setPlayers(r.data));
  }, []);

  return (
    <div className="space-y-5" data-testid="parent-dashboard">
      <div>
        <div className="font-label">Your children</div>
        <h1 className="font-heading uppercase text-3xl sm:text-4xl tracking-tight">Progress</h1>
        <p className="text-zinc-400 text-sm mt-1">
          Pick a child to see their coaches' shared observations and trend over time.
        </p>
      </div>

      {!players && <div className="skeleton h-24" />}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {players?.map((p) => (
          <Link
            key={p.id}
            to={`/players/${p.id}`}
            className="surface p-5 flex items-center justify-between hover:border-[#dfff00]/40 transition-colors"
            data-testid={`parent-child-${p.id}`}
          >
            <div className="flex items-center gap-3">
              <div className="w-14 h-14 rounded-md bg-[#1a1a1a] border border-[#27272a] flex items-center justify-center font-heading text-2xl">
                {p.name.split(" ").map((s) => s[0]).slice(0, 2).join("")}
              </div>
              <div>
                <div className="font-semibold text-lg">{p.name}</div>
                <div className="text-xs text-zinc-500 flex items-center gap-1 mt-1">
                  <ChartLineUp size={14} weight="bold" /> View progress
                </div>
              </div>
            </div>
            <CaretRight size={20} className="text-zinc-600" />
          </Link>
        ))}
        {players?.length === 0 && (
          <div className="surface p-6 text-zinc-400">
            No children linked to your account. Ask the club admin to set this up.
          </div>
        )}
      </div>
    </div>
  );
}
